import { track } from "../track";

type Params =
  | {
      type: "basic";
      email: string;
    }
  | {
      type: "google";
      email: string;
      quiz_id?: string;
    };

export const trackLogInScs = (params: Params) =>
  track({ event: "log_in_scs", ...params });
